<template>
  <div class="table-header mb-0 mt-5" :class="`${headerWidthClass}`">
    <div
      v-for="column in columns"
      :key="column.name"
      class="table-header-cell sticky-header-cell"
      :class="`table-header-cell-${column.name}`"
      :style="getColumnWidthStyle(column)"
    >
      <span
        class="table-header-cell-label p-0 ms-2 mb-1"
        data-bs-toggle="tooltip"
        data-bs-placement="left"
        :title="column.header.length > 25 ? column.header : ''"
      >
        {{
          column.header.length > 25
            ? column.header.slice(0, 25) + '...'
            : column.header
        }}
      </span>
      <button
        class="btn btn-link toggle-category-button p-0 w-100"
        @click="
          column.template === 'categories' ? onClickColumnHeader(column) : null
        "
      >
        <i
          v-if="column.template === 'categories'"
          :id="`toggle-category-${column.name}`"
          :ref="`toggle-category-icon-${column.name}`"
          class="bi p-0"
          :class="`${expandedCategory ? 'bi-arrows-collapse-vertical' : 'bi-arrows-expand-vertical'}`"
          data-bs-toggle="tooltip"
          data-bs-placement="left"
          :title="popoverTitle(column)"
        ></i>
      </button>
    </div>
  </div>
</template>

<script>
import { Tooltip } from 'bootstrap'

export default {
  name: 'PulsTableHeader',
  props: {
    columns: {
      type: Array,
      required: true
    },
    tableConfig: {
      type: Object,
      required: true
    },
    onClickColumnHeader: {
      type: Function,
      default: () => {}
    },
    expandedCategory: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      maxLengthForLabel: 30,
      maxLengthForNarrowHeader: 27
    }
  },
  computed: {
    headerWidthClass() {
      if (
        this.columns.some(
          (col) => col.title && col.title.length > this.maxLengthForNarrowHeader
        )
      ) {
        return 'wide-header'
      }
      return 'narrow-header'
    },
    truncatedHeader() {
      return this.column.header.length > 30
        ? this.column.header.slice(0, 30) + '...'
        : this.column.header
    }
  },
  watch: {
    expandedCategory() {
      this.refreshCategoryTooltips()
    }
  },
  mounted() {
    this.refreshCategoryTooltips()
  },
  methods: {
    popoverTitle(column) {
      return this.expandedCategory
        ? this.$t('resultDetails.backToResults')
        : `${this.$t('groupsComparison.questions')} ${column.header}`
    },
    refreshCategoryTooltips() {
      this.$nextTick(() => {
        this.columns.forEach((column) => {
          if (column.template !== 'categories') return
          const refName = `toggle-category-icon-${column.name}`
          const refs = this.$refs[refName]
          const refArray = Array.isArray(refs) ? refs : [refs]
          refArray.forEach((el) => {
            if (!el) return

            try {
              const tooltip = Tooltip.getInstance(el)
              if (tooltip) {
                tooltip.hide()
                tooltip._config.title = this.popoverTitle(column)
                tooltip.setContent({
                  '.tooltip-inner': this.popoverTitle(column)
                })
              }

              new Tooltip(el)
            } catch (e) {
              console.warn(`Tooltip init failed for ${refName}`, e)
            }
          })
        })
      })
    },
    getColumnWidthStyle(column) {
      let width = undefined
      if (!column.name) {
        return {
          maxWidth: 0 + 'px',
          minWidth: 0 + 'px'
        }
      }
      if (
        this.tableConfig.columnWidth.name &&
        this.tableConfig.columnWidth.name[column.name] !== undefined
      ) {
        width = this.tableConfig.columnWidth.name[column.name]
      } else if (
        this.tableConfig.columnWidth.template &&
        this.tableConfig.columnWidth.template[column.template] !== undefined
      ) {
        width = this.tableConfig.columnWidth.template[column.template]
      }

      let marginRight = 0
      if (this.tableConfig.columnWidth.margin[column.template]) {
        const marginColNames = this.columns.reduce((acc, col) => {
          if (col.template === column.template) {
            acc.push(col.name)
          }
          return acc
        }, [])
        if (column.name === marginColNames[marginColNames.length - 1]) {
          marginRight = this.tableConfig.columnWidth.margin[column.template]
        }
      }

      return width !== undefined
        ? {
            maxWidth: width + 'px',
            minWidth: width + 'px',
            overflow: width === 0 ? 'hidden' : 'visible',
            height: width === 0 ? '0px' : 'auto',
            margin: width === 0 ? '0px' : '2px',
            marginRight: marginRight === 0 ? '0px' : marginRight + 'px'
          }
        : {}
    }
  }
}
</script>

<style lang="scss" scoped>
.table-header {
  display: flex;
  align-items: flex-end;
}
.narrow-header {
  height: 150px;
}
.wide-header {
  height: 280px;
}

.table-header-cell {
  // transition:
  //   margin 0.2s ease,
  //   max-width 0.2s ease,
  //   min-width 0.2s ease;
  margin: 0px 2px;
}
.table-header-cell-label {
  display: block;
  transform: rotate(-70deg);
  overflow: visible;
  overflow-wrap: normal;
  white-space: nowrap;
}
.toggle-category-button:hover > i {
  color: var(--kt-primary-active);
}
</style>
